import type { WalletView } from "../state/context-view-types"

/** Presentation gate only. Liquidity execution must enforce ownership independently. */
export function canAccessLiquidity(
  wallet?: Pick<WalletView, "address" | "status">,
): boolean {
  const owner = import.meta.env.VITE_LIQUIDITY_OWNER_ADDRESS?.trim()
  if (!owner || !/^0x[0-9a-f]{40}$/i.test(owner) || /^0x0{40}$/i.test(owner))
    return false
  if (!wallet?.address || !/^0x[0-9a-f]{40}$/i.test(wallet.address))
    return false
  // SIWE expiry and network selection do not disconnect the wallet. Reconnection
  // and unavailable/disconnected states must not reuse a retained account.
  if (
    !["CONNECTED", "SIGNING_IN", "SESSION_EXPIRED", "WRONG_NETWORK"].includes(
      wallet.status,
    )
  )
    return false
  return wallet.address.toLowerCase() === owner.toLowerCase()
}
